import PLATFORM_FEATURE_CONFIG from './platform-feature-config';
import { RISK_PLATFORM_FEATURES } from './risk';
import { AUTHENTICATION_PLATFORM_FEATURES } from './authentication';
import { COMMERCIAL_PLATFORM_FEATURES } from './commercial';
import { PRICING_PLATFORM_FEATURES } from './pricing';
import { COMPLIANCE_PLATFORM_FEATURES } from './compliance';

/**
 * Aggregated feature keys from all modules
 */

export const PLATFORM_FEATURES = {
  ...RISK_PLATFORM_FEATURES,
  ...AUTHENTICATION_PLATFORM_FEATURES,
  ...COMMERCIAL_PLATFORM_FEATURES,
  ...PRICING_PLATFORM_FEATURES,
  ...COMPLIANCE_PLATFORM_FEATURES,
};

export const getPlatformFeatures = (platformCode) => PLATFORM_FEATURE_CONFIG[platformCode] || {};

export const isPlatformFeatureEnabled = (platformCode, featureKey) => {
  const platformConfig = PLATFORM_FEATURE_CONFIG[platformCode];
  if (!platformConfig) return false;
  return platformConfig[featureKey] === true;
};

export const getFeatureValue = (platformCode, featureKey) => {
  const platformConfig = PLATFORM_FEATURE_CONFIG[platformCode];
  if (!platformConfig) return null;
  return platformConfig[featureKey];
};
